/**
 * formatDateID — Format tanggal ISO ke "2 Juli 2026" + "09.25 WIB".
 *
 * Dipakai di Shipment Center supaya customer tidak melihat ISO mentah.
 *
 * formatDateID("2026-07-02T09:25:00Z") → "2 Juli 2026"
 * formatTimeID("2026-07-02T09:25:00Z") → "09.25 WIB"
 * formatDateTimeID(...) → "2 Juli 2026, 09.25 WIB"
 *
 * Tidak mengubah timezone — gunakan zona Asia/Jakarta supaya "WIB" benar.
 * Kembalikan "" untuk input invalid.
 */
const MONTHS = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

function partsAsiaJakarta(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  // Convert ke WIB (UTC+7) tanpa bergantung Intl untuk hasil deterministik
  const wib = new Date(d.getTime() + 7 * 3600 * 1000);
  return {
    day: wib.getUTCDate(),
    month: wib.getUTCMonth(),
    year: wib.getUTCFullYear(),
    hour: wib.getUTCHours(),
    minute: wib.getUTCMinutes(),
  };
}

export function formatDateID(iso) {
  const p = partsAsiaJakarta(iso);
  if (!p) return "";
  return `${p.day} ${MONTHS[p.month]} ${p.year}`;
}

export function formatTimeID(iso) {
  const p = partsAsiaJakarta(iso);
  if (!p) return "";
  const hh = String(p.hour).padStart(2, "0");
  const mm = String(p.minute).padStart(2, "0");
  return `${hh}.${mm} WIB`;
}

export function formatDateTimeID(iso) {
  const d = formatDateID(iso);
  const t = formatTimeID(iso);
  if (!d) return "";
  if (!t) return d;
  return `${d}, ${t}`;
}
